import React, { useContext } from 'react';

import { MarquesinaAlert } from './MarquesinaAlert';
import useMarquesina from '../hooks/useMarquesina';
import { makeStyles } from '@material-ui/core';
import { PortalContext } from '@portal/arq-portal-core';

const useStyles = makeStyles(() => ({
    marquesinaIcon:{
        fontSize: '25px',
        background: '#FFe7ca',
        borderRadius: '50%',
        color: '#aa4813',
        position: 'absolute',
        top: '3px',
        marginLeft: '45px',
    },
}));

interface MarquesinaProps {
    disposable: boolean;
    onClose?: (id: string) => void;
    onMarquesinaLoaded?: (id: string) => void;
    showOnMarquesinaOnlyIcon?: (id: string) => any;
    onlyIcon?:boolean;
};

export const Marquesina = ({ disposable, onClose, onMarquesinaLoaded, onlyIcon, showOnMarquesinaOnlyIcon }: MarquesinaProps) => {
    const classes = useStyles();
    const {user} = useContext(PortalContext);
    const {data} = useMarquesina(user?user.id:"");
    let datos = data?.Salida?.Resultado;
    let texto = undefined;
    if(datos){
        texto = datos?.Datos
        onMarquesinaLoaded && onMarquesinaLoaded(datos.IdMarquesina);
    }
    const manejarCerrar = () => {
        onClose && onClose(datos?.IdMarquesina);
    };
    
    return (
        <React.Fragment>
            {texto && onlyIcon && (showOnMarquesinaOnlyIcon?(showOnMarquesinaOnlyIcon(datos.IdMarquesina) && <i className={`icon-aviso-fixed-2 ${classes.marquesinaIcon}`}/>) : <i className={`icon-aviso-fixed-2 ${classes.marquesinaIcon}`}/>) }
            
            {texto && !onlyIcon && <MarquesinaAlert texto={texto} disposable={disposable} onClose={manejarCerrar}/>}  
        </React.Fragment>
    );
}